<div #header mat-dialog-title>Folders for this Report</div>
<div style="padding-left: 10px;">{{report.Description}}</div>

<mat-dialog-content>
    <!-- Grid -->
    <mat-table #table id="tblFolders" [dataSource]="foldersTableData" multiTemplateDataRows style="width: 100%;">
        <!-- ParentCheckbox -->
        <ng-container matColumnDef="Checkbox">
            <mat-header-cell *matHeaderCellDef translate>
                <tyl-checkbox id="parentCheckbox" name="parentCheckbox" [(checked)]="allCheckBox"
                [indeterminate]="checkIndeterminate" (change)="allCheckBoxChange()">
                </tyl-checkbox>
            </mat-header-cell>

            <mat-cell *matCellDef="let fdr; let j = dataIndex" class="print-ignore">
                <tyl-checkbox id="childCheckbox_{{j}}" name="childCheckbox_{{j}}"
                    [(checked)]="fdr.IsSelected" (change)="parentCheckBoxChange()"
                    (click)="$event.stopPropagation();">
                </tyl-checkbox>
            </mat-cell>
        </ng-container>

        <!-- My Folder -->
        <ng-container matColumnDef="FolderName">
            <mat-header-cell *matHeaderCellDef translate>
                My Folders
            </mat-header-cell>
            <mat-cell *matCellDef="let fdr">
                {{fdr.FolderName}}
            </mat-cell>
        </ng-container>

        <!-- Folder Description -->
        <ng-container matColumnDef="FolderDescription">
            <mat-header-cell *matHeaderCellDef translate>
                Description
            </mat-header-cell>
            <mat-cell *matCellDef="let fdr">
                {{fdr.FolderDescription}}
            </mat-cell>
        </ng-container>

        <!-- Row Definitions -->
        <mat-header-row *matHeaderRowDef="folderTableColumns; sticky: true;"></mat-header-row>
        <mat-row *matRowDef="let fdr; columns: folderTableColumns; let i = dataIndex" id="folder{{fdr.Id}}"
            tabIndex="0" style="padding:0px;overflow: hidden;">
        </mat-row>

    </mat-table>
</mat-dialog-content>

<mat-dialog-actions #footer>
    <div class='flex-footer-left'>

    </div>
    <div class='flex-footer-right'>
        <tyl-button image="save.png" label="Save" (click)="saveClick()"></tyl-button>
        <tyl-button image="Cancel.png" label="Cancel" (click)="cancelClick()"></tyl-button>
    </div>
</mat-dialog-actions>